import { ChainedCommands } from '@tiptap/core'
import { VFC } from 'react'
import { useTextEditor } from '../../context'
import type { TextEditorAsset } from '../../types'
import { ControlButton } from './ControlButton'
import type { BaseControlButtonProps } from './types'

type AssetLibraryControlButtonProps = BaseControlButtonProps & {
  onPickAssets: () => Promise<TextEditorAsset[]>
}

export const AssetLibraryControlButton: VFC<AssetLibraryControlButtonProps> = ({
  onPickAssets,
  ...buttonProps
}) => {
  const { editor } = useTextEditor()

  const pickAndInsertAssets = async (chain: ChainedCommands) => {
    const assets = await onPickAssets()
    const validAssets = assets.filter((asset) => asset?.assetUuid != null)
    const assetStore = editor.storage.asset.assetStore

    if (assetStore) {
      const newAssets = validAssets.filter(
        (asset) => !assetStore.some((a) => a.assetUuid === asset.assetUuid)
      )
      assetStore.push(...newAssets)
    }

    validAssets.forEach((asset) => chain.insertAsset(asset))

    // Wait for next tick so the asset store gets updated
    await new Promise((res) => setTimeout(res))

    return chain
  }

  return <ControlButton onClick={pickAndInsertAssets} {...buttonProps} />
}
